const state = {
  height: 0,
};

// getters
const getters = {};

// mutations
const mutations = {
  change_height(state, newData) {
    state.height = newData;
  },
};

// actions
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
